class LWCard extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
    }

    render() {
        this.shadowRoot.innerHTML = /* html */ ` 
        <style>
            :host {
                display: block;
                width: 100%;
                height: 100%;
                font-family: system-ui, sans-serif;
                --card-bg: var(--my-card-bg, #ffffff);
                --card-text: var(--my-card-text, #333);
            }

    .card {
        background: var(--card-bg);
        color: var(--card-text);
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #eee;
        display: flex;
        
        /* STANDAARD (Mobiel) */
        flex-direction: row;
        /* STAP 1: Zet een vaste minimale hoogte voor de rij */
        min-height: 100px; 
        height: 100%;
        width: 100%;
    }

    .image-container {
        /* STAP 2: Zorg dat het plaatje de volledige hoogte van de kaart vult */
        flex: 0 0 100px;
        display: flex;
    }

    .image-container ::slotted(img) {
        width: 100%;
        height: 100%; /* Dit vult nu die vaste 100px hoogte */
        object-fit: cover;
        display: block;
    }

    .content {
        padding: 12px;
        display: flex;
        flex-direction: column;
        /* STAP 3: Centreer de tekst verticaal in de beschikbare ruimte */
        justify-content: center; 
        flex-grow: 1;
    }

            /* MOBIEL: Verberg tekst en footer */
            .body-text, .footer {
                display: none;
            }

            .date {
                font-size: 0.75rem;
                color: #888;
                margin-bottom: 4px;
            }

            h2 {
                margin: 0;
                font-size: 1rem;
                line-height: 1.3;
            }

            /* DESKTOP: Boven de 600px schakelen we naar de volledige kaart */
            @media (min-width: 600px) {
                .card {
                    flex-direction: column;
                    border-radius: var(--radius, 12px);
                }
                
                .image-container {
                    flex: 0 0 auto;
                }

                .image-container ::slotted(img) {
                    height: 180px;
                }

                .content {
                    padding: 1.5rem;
                    justify-content: flex-start;
                }

                /* Toon tekst en footer weer op desktop */
                .body-text {
                    display: block;
                    line-height: 1.5;
                    margin: 1rem 0;
                    flex-grow: 1;
                }

                .footer {
                    display: block;
                    padding-top: 1rem;
                    border-top: 1px solid #f5f5f5;
                }

                h2 {
                    font-size: 1.25rem;
                }
            }
        </style>

        <article class="card">
            <div class="image-container">
                <slot name="image"></slot>
            </div>
            
            <div class="content">
                <div class="date"><slot name="date"></slot></div>
                <h2><slot name="title">Titel</slot></h2>
                
                <div class="body-text">
                    <slot></slot> 
                </div>

                <div class="footer">
                    <slot name="footer">
                        <lw-knop class="blauw">Lees meer</lw-knop>
                    </slot>
                </div>
            </div>
        </article>
        `;
    }
}

customElements.define('lw-card', LWCard);